<template>
<div>
    <div>
        <div class="enroll-nav-div-wrap">
            <div class="enroll-nav-div">
                <a href="#" class="enroll-logo-link w-inline-block">
                    <img sizes="(max-width: 479px) 67.21875px, 84.03125px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-800.png 800w, @/assets/images/NewSelf_Logo.png 1000w" alt="" src="@/assets/images/PriMeds_LogoUpdate.svg" loading="lazy" class="enroll-nav-logo-image">
                </a>
            </div>
        </div>
    </div>
    <div>
        <div class="enroll-div-wrap">
            <!-- Slide 1 -->
            <div class="enroll-slide-1" v-if="active_el==1">
                <div class="w-form">
                    <form @submit.prevent="handleSubmit">
                        <div class="_0_herodiv">
                            <img sizes="(max-width: 479px) 28vw, 15vw" srcset="@/assets/images/stepsimage_teledoc_nS-p-500.png 500w, @/assets/images/stepsimage_teledoc_nS.png 641w" alt="" src="@/assets/images/stepsimage_teledoc_nS.png" loading="lazy" class="enroll-top-image">
                            <div class="enroll-header">Welcome to NewSelf!</div>
                            <div class="enroll-sub">The following questions will will be used by a board certified physician licensed in your state to help create a treatment plan for you. <br/><strong>Please answer all questions accurately.</strong></div>
                            <div class="enroll-disclaimer-div"><label class="w-checkbox enroll-checkbox-field"><input type="checkbox" v-model="people.agreed_to_terms" required name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox top"><span class="enroll-checkbox-label w-form-label" for="checkbox-3">I Agree to NewSelf&#x27;s <a href="https://newselfrx.com/terms-of-use"  target="_blank" class="enroll-checkbox-link">Terms</a>, <a href="https://newselfrx.com/privacy-policy"  target="_blank" class="enroll-checkbox-link">Privacy Policy</a> and consent to <a href="https://newselfrx.com/telehealth-consent" target="_blank" class="enroll-checkbox-link">Telehealth</a></span></label></div>
                            <div class="enroll-3-things-div">
                                <div class="enroll-bullet-div">
                                    <img loading="lazy" src="@/assets/images/icon_testing-check-copy.svg" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">Free online medical evaluation</div>
                                </div>
                                <div class="enroll-bullet-div">
                                    <img loading="lazy" src="@/assets/images/icon_doctor-check-copy.svg" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">Board-certified physicians</div>
                                </div>
                                <div class="enroll-bullet-div">
                                    <img loading="lazy" src="@/assets/images/icon_delivery-check-copy.svg" alt="" class="enroll-bullet-image">
                                    <div class="enroll-bullet-text">Fast free shipping</div>
                                </div>
                            </div>

                            <div class="enroll-form-button-div"><input type="submit" data-wait="Please wait..." class="enroll-form-submit-button top w-button" value="Start my FREE visit -&gt;"></div>
                        </div>
                    </form>
                    <div class="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div class="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                </div>
            </div>

            <!-- Slide 2 -->
            <div class="enroll-slide-2 addmargin-mobile" v-if="active_el==2">
                <div class="enroll-form-header-div">
                    <div class="enroll-form-header-text">Let's start with the Basics</div>
                </div>

                <div class="enroll-form-block update w-form">
                    <form @submit.prevent="handleSubmit" class="enroll-form update">
                        <h1 class="enroll-form-question-text smaller a">Let's make sure we are licensed in your state</h1>
                        <select id="State-4" name="State-4" data-name="State 4" required v-model="people.state" class="select-field-3 form update w-select">
                            <option value="" disabled selected>State...</option>
                            <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}</option>
                        </select>

                        <h1 class="enroll-form-question-text smaller a">Who do I have the pleasure of talking to?</h1>
                        <div class="enroll-form-field-wrap-div update">
                            <input class="text-field-33 update w-input" maxlength="256" name="name" data-name="Name" v-model="people.first_name" placeholder="First Name" type="text" id="name">
                            <input class="text-field-33 update w-input" maxlength="256" v-model="people.last_name" name="Last-name" data-name="Last Name" placeholder="Last Name" type="text" id="Last-name" required>
                        </div>

                        <h1 class="enroll-form-question-text smaller">What was your gender at birth?</h1>
                        <div class="div-block-1893">
                            <label class="w-checkbox checkbox-field-18 male">
                                <input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" :checked="people.gender === 'Male'" @change="updateGender('Male')" class="w-checkbox-input enroll-checkbox">
                                <span class="checkbox-label-15 w-form-label" for="checkbox-4">Male</span>
                            </label>

                            <label class="w-checkbox checkbox-field-18 female">
                                <input type="checkbox" name="checkbox-4" id="male-checkbox" class="w-checkbox-input enroll-checkbox" :checked="people.gender === 'Female'" @change="updateGender('Female')">
                                <span class="checkbox-label-15 w-form-label" for="female-checkbox">Female</span>
                            </label>

                        </div>

                        <h1 class="enroll-form-question-text smaller">Please enter your email</h1>
                        <input class="text-field-33 email form update w-input" v-model="people.email" maxlength="256" name="Email-2" data-name="Email 2" placeholder="Enter your email" type="email" id="Email-2" required>

                        <div class="enroll-disclaimer-div form"><label class="w-checkbox enroll-checkbox-field form"><input type="checkbox" v-model="people.agreed_to_email" :checked="people.agreed_to_email" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox"><span class="enroll-checkbox-label form w-form-label" for="checkbox-3">I agree to receive doctor correspondence, transactional and/or marketing messaging
                                    from Yara to the email address that I provided above.</span></label></div>

                        <h1 class="enroll-form-question-text smaller">Please enter your mobile number {{ tempvalue }}</h1>
                        <div class="phone-entry-div update">
                            <input class="phone-number-field _1 form update w-input" @input="handlePhoneInput($event, 'areaCode')" pattern="[0-9]*" ref="areaCode" maxlength="3" name="field-2" data-name="Field 2" placeholder="(000)" type="tel" autocomplete="tel" id="field-2" required>
                            <div class="text-block-142">-</div>
                            <input class="phone-number-field form update w-input" @input="handlePhoneInput($event, 'prefix')" pattern="[0-9]*" ref="prefix" maxlength="3" name="field-2" data-name="Field 2" placeholder="000" type="text" id="field-2" required>
                            <div class="text-block-142">-</div>
                            <input class="phone-number-field _2 form update w-input" @input="handlePhoneInput($event, 'line')" pattern="[0-9]*" ref="line" maxlength="4" name="field-2" data-name="Field 2" placeholder="0000" type="text" id="field-2" required>
                        </div>

                        <h1 class="enroll-form-question-text smaller">Can we send you text messages about your prescription?</h1>
                        <div class="text-block-1018">(including tracking information and refill information)</div>
                        <div class="enroll-form-field-wrap-div update bottom">
                            <label class="w-checkbox checkbox-field-4 update">
                                <input type="checkbox" :checked="people.agreed_to_text === 'Yes'" @change="updateAgreement('Yes')" value="Yes" name="checkbox-2" id="checkbox-2" data-name="Checkbox 2" class="w-checkbox-input checkbox">
                                <span class="checkbox-label-4 w-form-label" for="checkbox-2">Yes</span>
                            </label>
                            <label class="w-checkbox checkbox-field-4 update">
                                <input type="checkbox" name="checkbox-2" id="checkbox-2" :checked="people.agreed_to_text === 'No'" @change="updateAgreement('No')" value="No" data-name="Checkbox 2" class="w-checkbox-input checkbox">
                                <span class="checkbox-label-4 w-form-label" for="checkbox-2">No</span>
                            </label>
                        </div>

                        <div class="enroll-disclaimer-div form"><label class="w-checkbox enroll-checkbox-field form">
                                <input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox" v-model="people.form_step2_agree" :checked="people.form_step2_agree">
                                <span class="enroll-checkbox-label form w-form-label" for="checkbox-3">By checking this box, I also consent by electronic signature to receive phone calls
                                    and/or SMS text messages at the phone number(s) below, including my wireless number if provided. I
                                    understand these calls may be generated using an automated technology, pre-recorded voices and that
                                    data rates may apply. I understand that my consent is not required to buy goods/services and I may opt
                                    out at any time to avoid receiving calls or SMS text messages.</span></label></div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button w-button" value="Next -&gt;">
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>

                </div>

                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Slide 3 -->
            <div class="enroll-slide-3 addmargin-mobile" v-if="active_el === 3">
                <h1 class="enroll-form-question-text">What is your date of birth?</h1>
                <p class="enroll-form-question-sub">Based on your date of birth our doctors can prescribe the proper prescription.</p>
                <div class="enroll-form-block b w-form">
                    <form @submit.prevent="validateDOB" class="enroll-form b">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="enroll-form-input-div mobile-entry form _2 weight">
                                <select v-model="people.dob.mm" class="select-field-5 felix w-select" required>
                                    <option value="">Month</option>
                                    <option value="01">January</option>
                                    <option value="02">February</option>
                                    <option value="03">March</option>
                                    <option value="04">April</option>
                                    <option value="05">May</option>
                                    <option value="06">June</option>
                                    <option value="07">July</option>
                                    <option value="08">August</option>
                                    <option value="09">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                                <div class="text-block-518">-</div>
                                <input class="phone-number-field-3 form birth felix w-input" maxlength="2" max="31" min="1" pattern="[0-9]*" v-model="people.dob.dd" placeholder="Day" type="number" required>
                                <div class="text-block-518">-</div>
                                <input class="phone-number-field-3 _2 form birth felix w-input" max="2024" min="1935" pattern="[0-9]*" v-model="people.dob.yyyy" placeholder="Year" type="number" required>
                            </div>
                        </div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button b w-button" value="Next -&gt;">
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>
                    
                </div>
                <div class="enroll-form-back-link-div">
                        <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                            <div class="enroll-form-back-text">&lt; Go Back</div>
                        </a>
                    </div>
            </div>

            <!-- Slide 4 -->
            <div class="enroll-slide-3 addmargin-mobile" v-if="active_el==4">
                <h1 class="enroll-form-question-text">What is your height and weight?</h1>
                <p class="enroll-form-question-sub">We'll use this to determine your Body mass Index (BMI) for diagnosis. remember, BMI is a measure of size - not health</p>
                <div class="enroll-form-block b w-form">
                    <form class="enroll-form b" @submit.prevent="handleSubmit">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="enroll-form-input-div mobile-entry form _2 height top">
                                <input class="enroll-form-text-field height w-input" maxlength="256" v-model="people.height.foot" @keyup="calculateBMI" name="feet" data-name="Feet" pattern="[0-9]*" placeholder="Feet" type="number" id="feet" required>
                                <div class="field-label-text">ft.</div>
                                <input class="enroll-form-text-field height update w-input" maxlength="256" v-model="people.height.inches" @keyup="calculateBMI" name="inches" pattern="[0-9]*" data-name="Inches" placeholder="Inches" type="number" id="inches" required>
                                <div class="field-label-text last">in.</div>
                            </div>
                            <div class="enroll-form-input-div mobile-entry form _2 weight">
                                <input class="enroll-form-text-field weight w-input" maxlength="256" name="weight-2" v-model="people.weight" @keyup="calculateBMI" pattern="[0-9]*" data-name="Weight 2" placeholder="Weight in pounds" type="number" id="weight-2" required>
                                <div class="field-label-text weight">lbs.</div>
                            </div>
                            <div v-if="people.bmi" class="bmi-result">
                                Your BMI: {{ people.bmi.toFixed(1) }}
                            </div>
                        </div>
                        <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button b w-button" value="Next -&gt;">
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>

                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

            <!-- Slide 5 -->

            <div class="enroll-slide-3 addmargin-mobile" v-if="active_el==5">
                <h1 class="enroll-form-question-text">What is your <strong>desired weight </strong>?</h1>
                <div class="enroll-form-block b update w-form">
                    <form class="enroll-form b" @submit.prevent="handleSubmit">
                        <div class="enroll-form-field-wrap-div b">
                            <div class="enroll-form-input-div mobile-entry form _2 weight"><input class="enroll-form-text-field weight w-input" maxlength="256" name="Goal-Weight" v-model="people.desired_weight" data-name="Goal Weight" placeholder="What is your goal weight in pounds?" type="text" id="Goal-Weight" required>
                                <div class="field-label-text weight">lbs.</div>
                            </div>
                        </div>
                        <button type="submit" class="enroll-form-submit-button b w-button" style="padding-top: 12px;" :disabled="isSubmitting">
                            <div v-if="isSubmitting">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1">
                                        </animateTransform>
                                    </circle>
                                </svg>
                            </div>
                            <div v-else>
                                Start my FREE visit ->
                            </div>
                        </button>
                        <div class="w-form-fail" style="display:block;" v-if="!isFormErrorEmpty">
                            <div v-for="(message, field) in formErrors" :key="field">{{ message }}</div>
                        </div>
                    </form>
                    
                </div>
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="GoBack()" class="enroll-form-back-link w-inline-block">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import state from "@/utils/state.json"
import {
    mapActions
} from 'vuex'
export default {
    name: 'WeightLossForm2',
    data() {
        return {
            allState: state,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            active_el: 1,
            tempvalue: '',
            formErrors: {},
            isSubmitting: false,
            people: {
                first_name: '',
                last_name: '',
                email: '',
                phone: {
                    areaCode: '',
                    prefix: '',
                    line: ''
                },
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agreed_to_email: true,
                desired_weight: '',
                state: '',
                agreed_to_terms: true,
                form_step2_agree: true,
                dobMMDDYYYY: 'NA',
                source_web:1,
                age:'',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
            }
        }
    },
    async mounted() {
        if(this.$route.query.sema){
            await this.$store.dispatch('addSemaOffer', this.$route.query.sema);
        }
        if(this.$route.query.tir){
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
    },
    computed: {
        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },
        phoneNumber() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone;
            return `${areaCode}${prefix}${line}`;
        },
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },
        calculatedBMI() {
            if (this.people.weight && this.people.heightInInches) {
                const heightInInches = parseFloat(this.people.heightInInches);
                const weightInPounds = parseFloat(this.people.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            }
            return null;
        }
    },
    methods: {
        ...mapActions([
            'setCartVisibility'
        ]),
        GoBack() {
            this.active_el--;
        },
        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            // Check if the date is valid
            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            // Ensure the year is between 1924 and the current year
            const currentYear = today.getFullYear();
            if (year < 1924 || year > currentYear) {
                return false;
            }

            // Ensure the date is not in the future
            if (date > today) {
                return false;
            }

            return true;
        },
        validateDOB() {
            const {
                mm,
                dd,
                yyyy
            } = this.people.dob
            if (!this.isValidDate(mm, dd, yyyy)) {
                this.isError = true
                return
            }

            this.people.dobMMDDYYYY = `${mm}/${dd}/${yyyy}`
            this.active_el++;
            this.isError = false
        },
        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches)
            const weightInPounds = parseInt(this.people.weight)
            this.people.bmi = (weightInPounds * 703) / (heightInInches * heightInInches)
            this.people.heightInInches = heightInInches;
            
        },
        updateAgreement(selectedValue) {
            // Toggle the agreement value
            this.people.agreed_to_text = this.people.agreed_to_text === selectedValue ? null : selectedValue;
        },
        updateGender(selectedGender) {
            // Toggle the gender selection
            this.people.gender = this.people.gender === selectedGender ? null : selectedGender;
        },
        validateStep1() {
            this.formErrors = {};
            if (!this.people.agreed_to_terms) {
                this.formErrors.terms = 'Please agree to the terms and conditions';
                return false;
            }
            return true;
        },
        validateStep2() {
            this.formErrors = {};

            if (!this.people.state) {
                this.formErrors.state = 'Please select your state';
                return false;
            }

            if (!this.people.first_name || !this.people.last_name) {
                this.formErrors.name = 'Please enter your full name';
                return false;
            }

            if (!this.people.gender) {
                this.formErrors.gender = 'Please select your gender';
                return false;
            }

            if (!this.isValidEmail) {
                this.formErrors.email = 'Please enter a valid email address';
                return false;
            }

            if (!this.people.agreed_to_email) {
                this.formErrors.emailConsent = 'Please agree to receive email communications';
                return false;
            }

            if (!this.phoneNumber || this.phoneNumber.length !== 10) {
                this.formErrors.phone = 'Please enter a valid phone number';
                return false;
            }

            return true;
        },
        validateStep3() {
            this.formErrors = {};

            const foot = parseInt(this.people.height.foot);
            const inches = parseInt(this.people.height.inches);
            const weight = parseFloat(this.people.weight);

            if (isNaN(foot) || isNaN(inches) || foot < 4 || foot > 8 || inches < 0 || inches > 11) {
                this.formErrors.height = 'Please enter a valid height';
                return false;
            }

            if (isNaN(weight) || weight < 80 || weight > 700) {
                this.formErrors.weight = 'Please enter a valid weight';
                return false;
            }

            // Calculate height in inches
            this.people.heightInInches = (foot * 12) + inches;
            // Calculate BMI
            this.people.bmi = this.calculatedBMI;

            return true;
        },

        validateStep4() {
            this.formErrors = {};

            const desiredWeight = parseFloat(this.people.desired_weight);
            const currentWeight = parseFloat(this.people.weight);

            if (isNaN(desiredWeight) || desiredWeight < 80 || desiredWeight > 700) {
                this.formErrors.desiredWeight = 'Please enter a valid desired weight';
                return false;
            }

            if (desiredWeight >= currentWeight) {
                this.formErrors.desiredWeight = 'Desired weight should be less than current weight';
                return false;
            }

            return true;
        },

        async handleSubmit() {
            this.formErrors = {};
            let isValid = false;

            switch (this.active_el) {
                case 1:
                    isValid = this.validateStep1();
                    break;
                case 2:
                    isValid = this.validateStep2();
                    break;
                case 3:
                    isValid = true;
                    break;
                case 4:
                    isValid = this.validateStep3();
                    break;
                case 5:
                    isValid = this.validateStep4();
                    break;
            }

            if (!isValid) {
                return;
            }

            if (this.active_el < 5) {
                this.active_el++;
                return;
            }

            // Final submission
            this.finalSubmit();

        },
        async finalSubmit() {
            try {
                if(this.people.bmi < 27){
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your BMI is less than 27. "
                        }
                    });
                    return false;
                }
                if(this.people.dob.yyyy > 2006){
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years. "
                        }
                    });
                    return false;
                }

                this.isSubmitting = true;
                // Replace with your API endpoint
                this.people.phone = this.phoneNumber;
                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, this.people, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                })
                if (response.data.status === 'success') {
                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.$router.push({
                        name: 'reportPage',
                        query:{
                            'desiredWeight': this.people.desired_weight
                        }
                    });
                }
            } catch (error) {
                console.error('Form submission error:', error);
                this.formErrors.submission = 'There was an error submitting your form. Please try again.';
            } finally {
                this.isSubmitting = false;
            }

        },
        goBack() {
            if (this.active_el > 1) {
                this.active_el--;
            }
        },

        handlePhoneInput(event, field) {
            const value = event.target.value.replace(/\D/g, '');
            if (value.length == 10) {
                const areaCodeLength = 3;
                const prefixLength = 3;
                const lineLength = 4;

                // Extract each part of the phone number based on its defined length
                this.people.phone.areaCode = value.slice(0, areaCodeLength);
                this.people.phone.prefix = value.slice(areaCodeLength, areaCodeLength + prefixLength);
                this.people.phone.line = value.slice(areaCodeLength + prefixLength, areaCodeLength + prefixLength + lineLength);
                
            }
            const maxLength = {
                areaCode: 3,
                prefix: 3,
                line: 4
            } [field];

            this.people.phone[field] = value.slice(0, maxLength);

            // Auto-focus next field
            if (value.length >= maxLength) {
                const nextField = {
                    areaCode: 'prefix',
                    prefix: 'line'
                } [field];

                if (nextField) {
                    this.$refs[nextField]?.focus();
                }
            }
            
        },

        handleGenderSelection(gender) {
            this.people.gender = gender;
        }
    },
    watch: {
        calculatedBMI(newBMI) {
            this.people.bmi = newBMI;
        },
        active_el() {
            window.scrollTo(0, 0)
        }
    }
}
</script>

<style scoped>
.enroll-top-image {
    width: 9%;
    margin-bottom: 15px;
}
.dob-page {
    width: 80% !important;
}

.checkbox-field-18.female {
    background-image: url(@/assets/images/Female.svg);
    background-size: 8%;
}

.checkbox-field-18.male {
    background-image: url(@/assets/images/Male.svg);
    background-size: 8%;
}

@media screen and (max-width: 479px) {
    .checkbox-field-18.female {
        background-size: 13%;
    }

    .checkbox-field-18.male {
        background-size: 13%;
    }

    .addmargin-mobile {
        margin-top: 20px;
    }
}

.bmi-result {
    margin: 20px 0;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
}

.dob-feild {
    width: 33%;
}

@media screen and (max-width: 479px) {
    .dob-feild {
        width: 100%;
    }
}
</style>
